import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION } from "@components/ReportField/consts";
import { useReport } from "@providers/ReportProvider";

// Whether "Send to Appendix" shows for the whole section. Appendix is a
// Diagnosis Evaluation concept — both the step viewer (evaluation) and the
// single-page viewer (clinical, behind db-single-page) support it; Assessment
// and Reassessment have no appendix.
export const useCanMoveSectionToAppendix = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();

  if (isReviewPage || isCompleted) return false;
  if (report.reportType !== ApiReportReportTypeChoices.DiagnosisEvaluation) return false;
  if (viewMode !== "step" && viewMode !== "single") return false;

  return section.pageLocation !== APPENDIX_PAGE_LOCATION;
};
